export const lightTheme = {
  title:"#0b057d",
  paragraph: "#546e7a",
  footerNav :"#fff",
  bg: "url(/background.jpg)",
  bg1: "",
  bg2: "#f9f9f9",
  bg3: "#ecf0f1",
  bg4: "#7da7d9",
  bg5: "",
  bgFeedback: "url(/feedback.jpg)",
  bgContact: "",
  text1: "#263238",
  text2: "#222",
  text3: "#5e6d74",
  // Bonus
  teamSocialColor: "#0303b6",
  teamSocialColorHover: "#030370",
  charityOdd: "#f8f8f8",
  socialFooterColor: "#f9f9f9",
  socialFooterbg: "rgb(7, 7, 139)",
  socialFooterColorHover: "rgb(18, 18, 221)",
  placeholder: "#6e6e6e",
  inputColor: "#222",
  btnCntact: "#007bff",
};

export const darkTheme = {
  title: "#f2f2f2",
  paragraph: "#c0c0c0",
  footerNav :"#c0c0c0",
  bg: "url(/black-background.jpg)",
  bg1: "#111",
  bg2: "#222",
  bg3: "#333",
  bg4: "#111",
  bg5: "#222",
  bgFeedback:"url(./black-feedback.jpg)",
  bgContact: "#333",
  text1: "#eeee",
  text2: "#ddd",
  text3: "#ccc",
  // Bonus
  teamSocialColor: "#f5ffff",
  teamSocialColorHover: "#c0c0c0",
  charityOdd: "#222",
  socialFooterColor: "#222",
  socialFooterbg: "#f9f9f9",
  socialFooterColorHover: "rgba(255, 255, 255,0.6)",
  placeholder: "#d1d1d1",
  inputColor: "#fff",
  btnCntact: "#555",
};
